const botUserAgentPatterns = [
	/HeadlessChrome/i,
	/Googlebot/i,
	/\b(bot|crawler|spider)\b/i,
	/meta-(externalagent|webindexer)/i,
];

// Keep automated clients out of browser telemetry and client-side error reporting.
export const isBotUserAgent = (userAgent = '') => botUserAgentPatterns.some((pattern) => pattern.test(userAgent));
